import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="mt-5 p-6 container">
        <div className="columns">
          <div className="column is-flex-grow-5">
            <div className="ant-card ant-card-bordered">
              <div className="ant-card-body">
                <h2 className="has-text-centered">Unlock in</h2>
                <div className="DetailPinkLockRecord_countdown__zzElI">
                  <div className="has-text-centered"><strong><span
                    className="p-2 has-background-danger-light mr-2"
                    style={{ borderRadius: "4px" }}>1000</span><span
                      className="p-2 has-background-danger-light mr-2"
                      style={{ borderRadius: "4px" }}>07</span><span
                        className="p-2 has-background-danger-light mr-2"
                        style={{ borderRadius: "4px" }}>39</span><span
                          className="p-2 has-background-danger-light mr-2"
                          style={{ borderRadius: "4px" }}>33</span></strong></div>
                </div>
              </div>
            </div>
            <div style={{ height: "18px" }}></div>
            <div>
              <div className="ant-card ant-card-bordered" style={{ height: "100%" }}>
                <div className="ant-card-head">
                  <div className="ant-card-head-wrapper">
                    <div className="ant-card-head-title">Pair Info</div>
                  </div>
                </div>
                <div className="ant-card-body">
                  <div className="ant-spin-nested-loading">
                    <div className="ant-spin-container">
                      <div className="table-container">
                        <table>
                          <tr>
                            <td>Pair Address</td>
                            <td className="has-text-right"><a href="https://bscscan.com/token/0x2C7866882201b4CEe229a7a801473d132DA56EeE" target="_blank" rel="nofollow noreferrer">0x2C7866882201b4CEe229a7a801473d132DA56EeE</a>
                            </td>
                          </tr>
                          <tr>
                            <td>Pair Name</td>
                            <td className="has-text-right">ROT/WBNB</td>
                          </tr>
                          <tr>
                            <td>Token</td>
                            <td className="has-text-right"><a href="https://bscscan.com/address/0xbcA3EF20282c1DaBfA1f1A996E7C61e6a92551a2" target="_blank" rel="nofollow noreferrer">ROT</a></td>
                          </tr>
                          <tr>
                            <td>Quote Token</td>
                            <td className="has-text-right"><a href="https://bscscan.com/address/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c" target="_blank" rel="nofollow noreferrer">Wrapped BNB</a></td>
                          </tr>
                          <tr>
                            <td>Dex</td>
                            <td className="has-text-right"><a href="https://pancakeswap.finance/swap?outputCurrency=0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c" target="_blank" rel="nofollow noreferrer">Pancakeswap</a></td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ height: "18px" }}></div>
              <div className="ant-card ant-card-bordered">
                <div className="ant-card-head">
                  <div className="ant-card-head-wrapper">
                    <div className="ant-card-head-title">Lock info</div>
                  </div>
                </div>
                <div className="ant-card-body">
                  <div className="ant-spin-nested-loading">
                    <div className="ant-spin-container">
                      <div className="table-container">
                        <table>
                          <tr>
                            <td>Total Amount Locked</td>
                            <td className="has-text-right">31,360.8035 </td>
                          </tr>
                          <tr>
                            <td>Total Values Locked</td>
                            <td className="has-text-right">$16,662</td>
                          </tr>
                          <tr>
                            <td>Owner</td>
                            <td className="has-text-right"><a href="https://bscscan.com/address/0xC96347e145A16e4DF5986dB050874B53E7b337A6" target="_blank" rel="nofollow noreferrer">0xC96347e145A16e4DF5986dB050874B53E7b337A6</a>
                            </td>
                          </tr>
                          <tr>
                            <td>Lock Date</td>
                            <td className="has-text-right">2022.11.18 16:05 UTC</td>
                          </tr>
                          <tr>
                            <td>Unlock Date</td>
                            <td className="has-text-right">2025.08.15 00:00 UTC (in 3 years)
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
